import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';

import { SwitchboardService } from '../../switchboard/switchboard.service';

import { OutboundServer } from './outbound-server.model';

declare var toastr: any;
declare var alertify: any;

@Component({
    selector: 'app-outbound-server',
    templateUrl: './outbound-server.component.html',
    styleUrls: ['./outbound-server.component.css']
})
export class OutboundServerComponent implements OnInit {

    servers: OutboundServer[];
    trunks: any[];

    current_server: OutboundServer = new OutboundServer();
    droplet_info: any;

    @ViewChild('serverDetail') serverDetail;
    @ViewChild('dropletInfo') dropletModal;

    constructor(
        private switchboardService: SwitchboardService
    ) { }

    ngOnInit() {
        this.switchboardService.getServerTrunks()
            .subscribe(trunks => this.trunks = trunks);
        this.loadServers();
    }

    loadServers() {
        this.servers = null;
        this.switchboardService.getOutboundServers()
            .subscribe(servers => this.servers = servers);
    }

    newServer() {
        this.current_server = new OutboundServer();
        this.serverDetail.title = 'New Server';
        this.serverDetail.open();
    }

    editServer(server) {
        this.current_server = server;
        this.serverDetail.title = 'Edit Server';
        this.serverDetail.open();
    }

    deleteServer(server) {
        alertify.confirm(`Are you sure you want to delete ${server.server_host}`, () => {
            this.switchboardService.deleteOutboundServer(server)
                .subscribe(_ => this.loadServers());
        });
    }

    getDropletInfo(server) {
        this.current_server = server;
        this.droplet_info = null;
        this.switchboardService.getServerDropletInfo('outbound', server)
            .subscribe(info => this.droplet_info = info);
        this.dropletModal.open();
    }

    saveServer() {
        let request;
        if (this.current_server.id) {
            request = this.switchboardService.updateOutboundServer(this.current_server);
        } else {
            request = this.switchboardService.createOutboundServer(this.current_server);
        }

        request.subscribe(response => {
            this.serverDetail.loading = false;
            if (response + '') {
                this.serverDetail.close();
                this.loadServers();
                toastr.success('Outbound Server Saved!');
            }
        });
    }

    commit(server: OutboundServer) {
        toastr.info(`Commiting ${server.name}`);
        this.switchboardService.commitOutboundServer(server.server_host)
            .subscribe(() => toastr.success(`${server.name} comitted!`));
    }

}
